import React from 'react';
import { useTranslation } from 'react-i18next';

const TypeButton = ({ data, cargarPopup }) => {
  const { t } = useTranslation();

  const buttonTp1 = () => {
    return (
      <button
        type="button"
        className="btn btn-default  u-full-width"
        onClick={() => cargarPopup(data)}
      >
        {t('vales.activarVale')}
      </button>
    );
  };

  const buttonTp2 = () => {
    return (
      // eslint-disable-next-line react/button-has-type
      <button className="btn btn-default btn__disable u-full-width">
        {t('vales.boton-activado')}
      </button>
    );
  };

  const buttonTp3 = () => {
    return (
      // eslint-disable-next-line react/button-has-type
      <button className="btn btn-default btn__disable u-full-width">
        {t('vales.boton-canjeado')}
      </button>
    );
  };
  return (
    <div className="botonera">
      {data.tipoLista === 1 && buttonTp1()}
      {data.tipoLista === 2 && buttonTp2()}
      {data.tipoLista === 3 && buttonTp3()}
    </div>
  );
};

export default TypeButton;
